module.exports = __webpack_public_path__ + "static/media/header.f35ce442.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feedback/header.png
// module id = 1910
// module chunks = 6